import { render, staticRenderFns } from "./tv-administration-list.vue?vue&type=template&id=5b582707&scoped=true&"
import script from "./tv-administration-list.vue?vue&type=script&lang=ts&"
export * from "./tv-administration-list.vue?vue&type=script&lang=ts&"
import style0 from "./tv-administration-list.vue?vue&type=style&index=0&id=5b582707&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b582707",
  null
  
)

export default component.exports